import { lazy } from 'react';
import LogIn from '../Authentication/components/LogIn';
import LogOut from '../Authentication/components/LogOut';
import Unauthorized from './views/Unauthorized';
import Dashboard from "../Dashboard";
import ManageApplications from "../ManageApplications/components";
import Reviewers from "../Reviewers/components";
import ManageReviewer from "../ManageReviewer/components";
import Search from "../Search/components";
import { AUTH_ROLES, REPORTS_LABELS } from "../util/constants";

const Applicant = lazy(() => import('../Applicant/components'));
const ManageHSCycles = lazy(() => import('../ManageHSCycles/components'));
const ReportsDash = lazy(() => import('../ReportsDash/components'));
const Report = lazy(() => import('../Report'));
const ConfigurationsMain = lazy(() => import('../Configurations'));

const StudentDashboard = lazy(() => import('../StudentDashboard'));

const PATHS = [
    {
        path: "/",
        title: "Dashboard",
        Component: Dashboard, 
        roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}, ${AUTH_ROLES.HONORS_REVIEWER}, ${AUTH_ROLES.SCHOLARS_REVIEWER}, ${AUTH_ROLES.STUDENT_EMPLOYEE}, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}, ${AUTH_ROLES.HONORS_PROGRAM_COORDINATOR}`,
    },
        { // Dashboard subpages
            title: "My Application",
            path: "/ApplicationStatus/:applicantEmployeeId",
            Component: StudentDashboard,
        },
        {
            path: "/applicant/:applicantEmployeeId/:programId/:term",
            title: "Applicant Details", 
            Component: Applicant, 
            roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.HONORS_REVIEWER}, ${AUTH_ROLES.HONORS_PROGRAM_COORDINATOR}, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}`,
        },
    {
        path: "/manage-applications",
        title: "Manage Applications",
        Component: ManageApplications,
    },
    {
        title: "Reports",
        path: "/reports",
        Component: ReportsDash,
        roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}`
    },
        { // Report subpages
            title: "Report - In Review",
            path: `/reports/${REPORTS_LABELS["inreview"].KEY}/:programId?`,
            Component: Report,
            roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}`,
        },
        { // Report subpages
            title: "Report - Past Due",
            path: `/reports/${REPORTS_LABELS["pastdue"].KEY}/:programId?`,
            Component: Report,
            roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}`,
        },
        { // Report subpages
            title: "Report - Not Started",
            path: `/reports/${REPORTS_LABELS["notstarted"].KEY}/:programId?`,
            Component: Report,
            roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}`,
        },
        { // Report subpages
            title: getReportTitle,
            path: "/reports/:reportId/:programId?",
            Component: Report,
            roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}`,
        },
    {
        path: "/reviewers/:active?/:bulk?",
        title: "Reviewers",
        Component: Reviewers,
        roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}`,
    },
        { // Manage Reviewers subpages
            title: "Manage Reviewer",
            path: "/reviewer/:reviewerEmployeeId?",
            Component: ManageReviewer,
            roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}`,
        },
    {
        path: "/configurations/:programId?",
        title: "Configurations",
        Component: ConfigurationsMain, 
        roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}`,
    },
    {
        path: "/search/:param?",
        title: "Search",
        Component: Search,
        roles: `${AUTH_ROLES.ADMIN_ACCESS}, ${AUTH_ROLES.HONORS_ADMIN}, ${AUTH_ROLES.SCHOLARS_ADMIN}, STUDENT, ${AUTH_ROLES.HONORS_SEASONAL_MANAGER}, ${AUTH_ROLES.HONORS_PROGRAM_COORDINATOR}`,
    },
    {
        title: "Manage Cycles",
        path: "/manage-cycles",
        Component: ManageHSCycles,
    },
];

function getReportTitle({ location, params }) {
    const reportLabel = REPORTS_LABELS[params?.reportId]?.LABEL ?? "Unknown report";
    return `Report - ${reportLabel}`;
}

export const authorizationRoutes = {
    login: "/login",
    logout: "/logout",
    unauthorized: "/unauthorized",
  };

const authenticationFlowPaths = [
    {
        path: authorizationRoutes.login,
        title: "Log In",
        Component: LogIn 
    },
    {
        path: authorizationRoutes.logout,
        title: "Log Out",
        Component: LogOut 
    },
    {
        path: authorizationRoutes.unauthorized,
        title: "Not authorized",
        Component: Unauthorized 
    }
]

export {
    authenticationFlowPaths,
    PATHS as default
}